export const DATA_LEGAL = {
  documents: {
    termsAndConditions: {},
    privacy: {},
    termsOfUse: {},
  },
  general: {},
};

export const STATUS_DEFAULT = {
  IDLE: true,
  LOADING: false,
  LOADED: false,
  ERROR: false,
};

export const MUTATIONS = {
  SET_STATUS: 'setStatus',
  SET_LEGAL_DATA: 'setLegalData',
};

export default {
  namespaced: true,
  state: {
    STATUS: { ...STATUS_DEFAULT },
    data: { ...DATA_LEGAL },
  },
  mutations: {
    setLegalData(state, value) {
      state.data.general = {
        ...state.data.general,
        ...value,
      };
      state.data.documents.termsAndConditions = value.cs_operator.document[0].document;
      state.data.documents.termsOfUse = value.generic[1].document;
      state.data.documents.privacy = value.generic[0].document;
    },
    setStatus(state, value) {
      const states = Object.keys(state.STATUS);
      if (states.indexOf(value) > -1) {
        states.forEach((key) => {
          state.STATUS[key] = (key === value);
        });
      }
    },
  },
  actions: {
    getLegalDocuments({
      commit,
      rootState,
    }) {
      const api = rootState.Setup.apiInstance;
      commit(MUTATIONS.SET_STATUS, 'LOADING');
      return new Promise((resolve, reject) => {
        api.getLegalDocs()
          .then((response) => {
            commit(MUTATIONS.SET_STATUS, 'LOADED');
            commit(MUTATIONS.SET_LEGAL_DATA, response.data);
          })
          .catch((error) => {
            commit(MUTATIONS.SET_STATUS, 'ERROR');
            reject(error);
          });
      });
    },
  },
  modules: {
  },
};
